export const initialConsumerState = {
  'CONSUMER-DART': false,
  'CONSUMER-RAP': false,
  'CONSUMER-TR': false,
  'CONSUMER-ACHT': false,
  'CONSUMER-CCX': false,
  'CONSUMER-CONCESSION_RATE': false,
};

export const initialD2State = {
  'D2-RAP': false,
  'D2-TR': false,
  'D2-ACHT': false,
  'D2-DCR': false,
  'D2-CCX': false,
};

export const initialAggregatedState = {
  'TOTAL-RAP': false,
  'TOTAL-TR': false,
  'TOTAL-ACHT': false,
  'TOTAL-CCX': false,
};

export const initialSDSState = {
  'SDS-RAP': false,
  'SDS-TR': false,
  'SDS-ACHT': false,
  'SDS-CCX': false,
  'SDS-SDR': false,
};

export const initialCAPState = {
  'CAP-POLICY_ADHERENCE': false,
  'CAP-ACHT': false,
  'CAP-UNDERSTANDABILITY_NO_CONCESSION': false,
  'CAP-UNDERSTANDABILITY_CONCESSION_ISSUED': false,
  'CAP-HMD_OFFER_RATE': false,
};

export const initialAmazonBusinessState = {
  'AMAZON_BUSINESS-RAP': false,
  'AMAZON_BUSINESS-UNDERSTANDABILITY': false,
  'AMAZON_BUSINESS-TR': false,
  'AMAZON_BUSINESS-DART': false,
  'AMAZON_BUSINESS-ACHT': false,
  'AMAZON_BUSINESS-CONCESSION_RATE': false,
};

export const initialItalyState = {
  'TOTAL_CSC-RAP': false,
  'TOTAL_CSC-PRR': false,
  'TOTAL_CSC-HMD_RESPONSE_RATE': false,
};

export const initialTotalQCSState = {
  'TOTAL_QCS-DART': false,
  'TOTAL_QCS-RAP': false,
  'TOTAL_QCS-TR': false,
  'TOTAL_QCS-ACHT': false,
  'TOTAL_QCS-CCX': false,
};

export const initialConsumerQCSState = {
  'CONSUMER_QCS-DART': false,
  'CONSUMER_QCS-RAP': false,
  'CONSUMER_QCS-TR': false,
  'CONSUMER_QCS-ACHT': false,
  'CONSUMER_QCS-CCX': false,
};

export const initialConsumerExpand = {
  'CONSUMER-DART': true,
  'CONSUMER-RAP': true,
  'CONSUMER-TR': true,
  'CONSUMER-ACHT': true,
  'CONSUMER-CCX': true,
};

export const initialD2StateExpand = {
  'D2-RAP': true,
  'D2-TR': true,
  'D2-ACHT': true,
  'D2-DCR': true,
  'D2-CCX': true,
};

export const initialAggregatedStateExpand = {
  'TOTAL-RAP': true,
  'TOTAL-TR': true,
  'TOTAL-ACHT': true,
  'TOTAL-CCX': true,
};

export const initialSDSStateExpand = {
  'SDS-RAP': true,
  'SDS-TR': true,
  'SDS-ACHT': true,
  'SDS-CCX': true,
  'SDS-SDR': true,
};

export const initialCAPStateExpand = {
  'CAP-POLICY_ADHERENCE': true,
  'CAP-ACHT': true,
  'CAP-UNDERSTANDABILITY_NO_CONCESSION': true,
  'CAP-UNDERSTANDABILITY_CONCESSION_ISSUED': true,
  'CAP-HMD_OFFER_RATE': true,
};

export const initialAmazonBusinessStateExpand = {
  'AMAZON_BUSINESS-RAP': true,
  'AMAZON_BUSINESS-UNDERSTANDABILITY': true,
  'AMAZON_BUSINESS-TR': true,
  'AMAZON_BUSINESS-DART': true,
  'AMAZON_BUSINESS-ACHT': true,
  'AMAZON_BUSINESS-CONCESSION_RATE': true,
};

export const initialItalyStateExpand = {
  'TOTAL_CSC-RAP': true,
  'TOTAL_CSC-PRR': true,
  'TOTAL_CSC-HMD_RESPONSE_RATE': true,
};

export const initialTotalQCSStateExpand = {
  'TOTAL_QCS-DART': true,
  'TOTAL_QCS-RAP': true,
  'TOTAL_QCS-TR': true,
  'TOTAL_QCS-ACHT': true,
  'TOTAL_QCS-CCX': true,
};

export const initialConsumerQCSStateExpand = {
  'CONSUMER_QCS-DART': true,
  'CONSUMER_QCS-RAP': true,
  'CONSUMER_QCS-TR': true,
  'CONSUMER_QCS-ACHT': true,
  'CONSUMER_QCS-CCX': true,
};

//=====START: V2 Vertical States=====
export const initialConsumerV2State = {
  'CONSUMER_V2-CCX': false,
  'CONSUMER_V2-CCX_NEG_ONEBOX': false,
  'CONSUMER_V2-ACHT': false,
  'CONSUMER_V2-TR': false,
  'CONSUMER_V2-FCR': false,
};

export const initialD2V2State = {
  'D2_V2-RAP': false,
  'D2_V2-CCX': false,
  'D2_V2-CCX_NEG_ONEBOX': false,
  'D2_V2-ACHT': false,
  'D2_V2-TR': false,
  'D2_V2-DCR': false,
  'D2_V2-FCR': false,
};

export const initialAggregatedV2State = {
  'TOTAL_V2-CCX': false,
  'TOTAL_V2-CCX_NEG_ONEBOX': false,
  'TOTAL_V2-ACHT': false,
  'TOTAL_V2-TR': false,
};

export const initialSDSV2State = {
  'SDS_V2-RAP': false,
  'SDS_V2-CCX': false,
  'SDS_V2-CCX_NEG_ONEBOX': false,
  'SDS_V2-ACHT': false,
  'SDS_V2-TR': false,
  'SDS_V2-FCR': false,
  'SDS_V2-SDR': false,
};

export const initialCAPV2State = {
  'CAP_V2-CCX': false,
  'CAP_V2-CCX_NEG_ONEBOX': false,
  'CAP_V2-ACHT': false,
  'CAP_V2-TR': false,
  'CAP_V2-POLICY_ADHERENCE': false,
};

export const initialAmazonBusinessV2State = {
  'AMAZON_BUSINESS_V2-RAP': false,
  'AMAZON_BUSINESS_V2-CCX': false,
  'AMAZON_BUSINESS_V2-CCX_NEG_ONEBOX': false,
  'AMAZON_BUSINESS_V2-ACHT': false,
  'AMAZON_BUSINESS_V2-TR': false,
  'AMAZON_BUSINESS_V2-CONCESSION_RATE': false,
  'AMAZON_BUSINESS_V2-DART': false,
};

export const initialConsumerGOV2State = {
  'CONSUMER_GO_V2-RAP': false,
  'CONSUMER_GO_V2-CCX': false,
  'CONSUMER_GO_V2-CCX_NEG_ONEBOX': false,
  'CONSUMER_GO_V2-ACHT': false,
  'CONSUMER_GO_V2-TR': false,
  'CONSUMER_GO_V2-DART': false,
  'CONSUMER_GO_V2-CONCESSION_RATE': false,
};

export const initialD2GOV2State = {
  'D2_GO_V2-RAP': false,
  'D2_GO_V2-CCX': false,
  'D2_GO_V2-CCX_NEG_ONEBOX': false,
  'D2_GO_V2-ACHT': false,
  'D2_GO_V2-TR': false,
  'D2_GO_V2-DCR': false,
};

export const initialAggregatedGOV2State = {
  'TOTAL_GO_V2-RAP': false,
  'TOTAL_GO_V2-CCX': false,
  'TOTAL_GO_V2-CCX_NEG_ONEBOX': false,
  'TOTAL_GO_V2-ACHT': false,
  'TOTAL_GO_V2-TR': false,
};

export const initialSDSGOV2State = {
  'SDS_GO_V2-RAP': false,
  'SDS_GO_V2-CCX': false,
  'SDS_GO_V2-CCX_NEG_ONEBOX': false,
  'SDS_GO_V2-ACHT': false,
  'SDS_GO_V2-TR': false,
  'SDS_GO_V2-SDR': false,
};

export const initialCAPGOV2State = {
  'CAP_GO_V2-CCX': false,
  'CAP_GO_V2-CCX_NEG_ONEBOX': false,
  'CAP_GO_V2-ACHT': false,
  'CAP_GO_V2-POLICY_ADHERENCE': false,
  'CAP_GO_V2-HMD_OFFER_RATE': false,
  'CAP_GO_V2-UNDERSTANDABILITY_CONCESSION_ISSUED': false,
  'CAP_GO_V2-UNDERSTANDABILITY_NO_CONCESSION': false,
};

export const initialAmazonBusinessGOV2State = {
  'AMAZON_BUSINESS_GO_V2-RAP': false,
  'AMAZON_BUSINESS_GO_V2-CCX': false,
  'AMAZON_BUSINESS_GO_V2-CCX_NEG_ONEBOX': false,
  'AMAZON_BUSINESS_GO_V2-ACHT': false,
  'AMAZON_BUSINESS_GO_V2-TR': false,
  'AMAZON_BUSINESS_GO_V2-CONCESSION_RATE': false,
  'AMAZON_BUSINESS_GO_V2-DART': false,
  'AMAZON_BUSINESS_GO_V2-UNDERSTANDABILITY': false,
};
//=====END: V2 Vertical States=====

//=====START: V2 Vertical Expands=====
export const initialConsumerV2Expand = {
  'CONSUMER_V2-CCX': true,
  'CONSUMER_V2-CCX_NEG_ONEBOX': true,
  'CONSUMER_V2-ACHT': true,
  'CONSUMER_V2-TR': true,
  'CONSUMER_V2-FCR': true,
};

export const initialD2V2StateExpand = {
  'D2_V2-RAP': true,
  'D2_V2-CCX': true,
  'D2_V2-CCX_NEG_ONEBOX': true,
  'D2_V2-ACHT': true,
  'D2_V2-TR': true,
  'D2_V2-DCR': true,
};

export const initialAggregatedV2StateExpand = {
  'TOTAL_V2-CCX': true,
  'TOTAL_V2-CCX_NEG_ONEBOX': true,
  'TOTAL_V2-ACHT': true,
  'TOTAL_V2-TR': true,
};

export const initialSDSV2StateExpand = {
  'SDS_V2-RAP': true,
  'SDS_V2-CCX': true,
  'SDS_V2-CCX_NEG_ONEBOX': true,
  'SDS_V2-ACHT': true,
  'SDS_V2-TR': true,
  'SDS_V2-FCR': true,
  'SDS_V2-SDR': true,
};

export const initialCAPV2StateExpand = {
  'CAP_V2-CCX': true,
  'CAP_V2-CCX_NEG_ONEBOX': true,
  'CAP_V2-ACHT': true,
  'CAP_V2-TR': true,
  'CAP_V2-POLICY_ADHERENCE': true,
};

export const initialAmazonBusinessV2StateExpand = {
  'AMAZON_BUSINESS_V2-RAP': true,
  'AMAZON_BUSINESS_V2-CCX': true,
  'AMAZON_BUSINESS_V2-CCX_NEG_ONEBOX': true,
  'AMAZON_BUSINESS_V2-ACHT': true,
  'AMAZON_BUSINESS_V2-TR': true,
  'AMAZON_BUSINESS_V2-CONCESSION_RATE': true,
  'AMAZON_BUSINESS_V2-DART': true,
};

export const initialConsumerGOV2Expand = {
  'CONSUMER_GO_V2-RAP': true,
  'CONSUMER_GO_V2-CCX': true,
  'CONSUMER_GO_V2-CCX_NEG_ONEBOX': true,
  'CONSUMER_GO_V2-ACHT': true,
  'CONSUMER_GO_V2-TR': true,
  'CONSUMER_GO_V2-DART': true,
  'CONSUMER_GO_V2-CONCESSION_RATE': true,
};

export const initialD2GOV2StateExpand = {
  'D2_GO_V2-RAP': true,
  'D2_GO_V2-CCX': true,
  'D2_GO_V2-CCX_NEG_ONEBOX': true,
  'D2_GO_V2-ACHT': true,
  'D2_GO_V2-TR': true,
  'D2_GO_V2-DCR': true,
};

export const initialAggregatedGOV2StateExpand = {
  'TOTAL_GO_V2-RAP': true,
  'TOTAL_GO_V2-CCX': true,
  'TOTAL_GO_V2-CCX_NEG_ONEBOX': true,
  'TOTAL_GO_V2-ACHT': true,
  'TOTAL_GO_V2-TR': true,
};

export const initialSDSGOV2StateExpand = {
  'SDS_GO_V2-RAP': true,
  'SDS_GO_V2-CCX': true,
  'SDS_GO_V2-CCX_NEG_ONEBOX': true,
  'SDS_GO_V2-ACHT': true,
  'SDS_GO_V2-TR': true,
  'SDS_GO_V2-SDR': true,
};

export const initialCAPGOV2StateExpand = {
  'CAP_GO_V2-CCX': true,
  'CAP_GO_V2-CCX_NEG_ONEBOX': true,
  'CAP_GO_V2-ACHT': true,
  'CAP_GO_V2-POLICY_ADHERENCE': true,
  'CAP_GO_V2-HMD_OFFER_RATE': true,
  'CAP_GO_V2-UNDERSTANDABILITY_CONCESSION_ISSUED': true,
  'CAP_GO_V2-UNDERSTANDABILITY_NO_CONCESSION': true,
};

export const initialAmazonBusinessGOV2StateExpand = {
  'AMAZON_BUSINESS_GO_V2-RAP': true,
  'AMAZON_BUSINESS_GO_V2-CCX': true,
  'AMAZON_BUSINESS_GO_V2-CCX_NEG_ONEBOX': true,
  'AMAZON_BUSINESS_GO_V2-ACHT': true,
  'AMAZON_BUSINESS_GO_V2-TR': true,
  'AMAZON_BUSINESS_GO_V2-CONCESSION_RATE': true,
  'AMAZON_BUSINESS_GO_V2-DART': true,
  'AMAZON_BUSINESS_GO_V2-UNDERSTANDABILITY': true,
};
//=====END: V2 Vertical Expands=====

export const initVerticalCardState = (vertical: any) => {
  if (vertical === 'Consumer') return initialConsumerState;
  if (vertical === 'D2') return initialD2State;
  if (vertical === 'Total') return initialAggregatedState;
  if (vertical === 'SDS') return initialSDSState;
  if (vertical === 'CAP') return initialCAPState;
  if (vertical === 'Amazon Business') return initialAmazonBusinessState;
  if (vertical === 'Total_CSC') return initialItalyState;
  if (vertical === 'Total_QCS') return initialTotalQCSState;
  if (vertical === 'Consumer_QCS') return initialConsumerQCSState;
  // V2 Verticals
  if (vertical === 'Consumer_V2') return initialConsumerV2State;
  if (vertical === 'Consumer_GO_V2') return initialConsumerGOV2State;
  if (vertical === 'D2_V2') return initialD2V2State;
  if (vertical === 'D2_GO_V2') return initialD2GOV2State;
  if (vertical === 'Total_V2') return initialAggregatedV2State;
  if (vertical === 'Total_GO_V2') return initialAggregatedGOV2State;
  if (vertical === 'SDS_V2') return initialSDSV2State;
  if (vertical === 'SDS_GO_V2') return initialSDSGOV2State;
  if (vertical === 'CAP_V2') return initialCAPV2State;
  if (vertical === 'CAP_GO_V2') return initialCAPGOV2State;
  if (vertical === 'Amazon Business V2') return initialAmazonBusinessV2State;
  if (vertical === 'Amazon Business GO V2')
    return initialAmazonBusinessGOV2State;
  return initialConsumerState;
};

export const expandAll = (vertical: any) => {
  if (vertical === 'Consumer') return initialConsumerExpand;
  if (vertical === 'D2') return initialD2StateExpand;
  if (vertical === 'Total') return initialAggregatedStateExpand;
  if (vertical === 'SDS') return initialSDSStateExpand;
  if (vertical === 'CAP') return initialCAPStateExpand;
  if (vertical === 'Amazon Business') return initialAmazonBusinessStateExpand;
  if (vertical === 'Total_CSC') return initialItalyStateExpand;
  if (vertical === 'Total_QCS') return initialTotalQCSStateExpand;
  if (vertical === 'Consumer_QCS') return initialConsumerQCSStateExpand;
  // V2 Verticals
  if (vertical === 'Consumer_V2') return initialConsumerV2Expand;
  if (vertical === 'Consumer_GO_V2') return initialConsumerGOV2Expand;
  if (vertical === 'D2_V2') return initialD2V2StateExpand;
  if (vertical === 'D2_GO_V2') return initialD2GOV2StateExpand;
  if (vertical === 'Total_V2') return initialAggregatedV2StateExpand;
  if (vertical === 'Total_GO_V2') return initialAggregatedGOV2StateExpand;
  if (vertical === 'SDS_V2') return initialSDSV2StateExpand;
  if (vertical === 'SDS_GO_V2') return initialSDSGOV2StateExpand;
  if (vertical === 'CAP_V2') return initialCAPV2StateExpand;
  if (vertical === 'CAP_GO_V2') return initialCAPGOV2StateExpand;
  if (vertical === 'Amazon Business V2')
    return initialAmazonBusinessV2StateExpand;
  if (vertical === 'Amazon Business GO V2')
    return initialAmazonBusinessGOV2StateExpand;
  return initialConsumerExpand;
};

export const verticalCardStateSwitch = (state: any, action: any) => {
  switch (action.type) {
    case 'on':
      return { ...state, [action.verticalCard]: true };
    case 'off':
      return { ...state, [action.verticalCard]: false };
    case 'init':
      return initVerticalCardState(action.vertical);
    case 'expandAll':
      return expandAll(action.vertical);
    default:
      throw new Error();
  }
};
